import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "configurator-footer"
};
const _hoisted_3 = {
  class: "container-fluid"
};
const _hoisted_4 = {
  class: "text-left"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  class: "container"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "container-product"
};
const _hoisted_10 = {
  class: "container"
};
const _hoisted_11 = {
  class: "configurator-footer"
};
const _hoisted_12 = {
  class: "container-fluid"
};
const _hoisted_13 = {
  class: "text-left"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "container"
};
const _hoisted_16 = ["innerHTML"];
import { computed } from "vue";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
export default /*@__PURE__*/_defineComponent({
  __name: 'commonFooter',
  props: ["layoutProducts"],
  setup(__props) {
    const props = __props;
    const additionalStore = useAdditionalAttrStore();
    const getCopyright = computed(() => {
      const date = new Date();
      return additionalStore.config.company.replace(/#currentYear#/, date.getFullYear() + "");
    });
    return (_ctx, _cache) => {
      const _component_el_link = _resolveComponent("el-link");
      return !props.layoutProducts ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "content",
        innerHTML: _ctx.$t('footer.text')
      }, null, 8, _hoisted_5), _createVNode(_component_el_link, {
        href: "https://wika.de/",
        target: "_blank",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("footer.link")), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
        innerHTML: getCopyright.value
      }, null, 8, _hoisted_7)])])])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: "content footer",
        innerHTML: _ctx.$t('footer.text')
      }, null, 8, _hoisted_14), _createVNode(_component_el_link, {
        href: "https://wika.de/",
        target: "_blank",
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("footer.link")), 1)]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
        innerHTML: getCopyright.value
      }, null, 8, _hoisted_16)])])])])]));
    };
  }
});